// extracted by mini-css-extract-plugin
export default {"PlaynGo":"PlaynGo_PlaynGo__ZucmX","Logo":"PlaynGo_Logo__YjkCD"};